module.exports = __webpack_public_path__ + "img/sm-facebook.54cceeaa.svg";